import _ from 'lodash';
import React from 'react'
import { navigate } from '@reach/router';
import { Link } from 'gatsby'
import posed from 'react-pose'
import styled from 'styled-components'
import SideBar from './SideBar'
import SlideControl from '../molecules/SlideControl'

const Container = styled.div`
  min-width: 100vw;
  min-height: 100vh;
`

class FullPageSlide extends React.Component {
  state = {
    loaded: false,
    sidebar: false,
    isOpen: false
  }

  constructor(props) {
    super(props)

    this.delayedCallback = _.throttle(this.slideToPage, 2000, { 'trailing': false })
  }

  onWheel(e) {
    /*
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    e.preventDefault();
    e.returnValue = false;

    const { isOpen } = this.state;

    if (!isOpen) {
      //this.delayedCallback(e.deltaY)
    }
    */
  }

  slideToPage(delta) {
    const { loaded } = this.state
    const { prev, next } = this.props

    if (loaded) {
      if (prev && delta < 0) {
        navigate(prev)
      } else if (next && delta > 0) {
        navigate(next)
      }
    }
    else {
      this.setState({ loaded: true })
    }
  }

  toggle = () => this.setState({ isOpen: !this.state.isOpen });

  componentDidMount() {
    this.setState({ sidebar: true })
  }

  render() {
    const { sidebar, isOpen } = this.state

    return (
      <Container onWheel={this.onWheel.bind(this)}>
        {sidebar && <SideBar isOpen={isOpen} toggle={this.toggle}/>}
        <SlideControl/>
        {this.props.children}
      </Container>
    )
  }
}

export default FullPageSlide
